/**
   * The way to filter each property.
   *
   * - `length`: Check the length of the proeprty, ie: logs, comments, changes.
   * - `value`: For matching key/value pairs,, ie: _id's, levels, usernames.
   *
   * @note When the property is not listed here, type `value` is used as default,
   *  since it's most common, and to prevent mistakes in the future (why doesn't
   *  my filter work?). For the sake of completion, all the current filters have
   *  their properties listed here.
   */
  export const FILTER_PROPERTY_BY = {
    commentCount: 'value',
    constructionId: 'value',
    moduleId: 'value',
    projectId: 'value',
    submoduleId: 'value'
  };
